// extracted by mini-css-extract-plugin
export default {"wrapper":"Xo","form":"Yo","preference":"Zo","request":"_o","job":"ap","smallprint":"bp","asterisk":"cp","success":"dp","circle":"ep"};